var map = {
	"./bootstrap.png": 875,
	"./css.png": 102,
	"./database.png": 693,
	"./draw.png": 450,
	"./figma.png": 519,
	"./gaming.png": 633,
	"./github.png": 56,
	"./gta.png": 542,
	"./html.png": 464,
	"./javascript.png": 857,
	"./kitty.png": 841,
	"./movie.png": 582,
	"./nodejs.png": 151,
	"./photoshop.png": 423,
	"./rdr.png": 158,
	"./react.png": 961,
	"./sass.png": 628,
	"./storybook.png": 558,
	"./typescript.png": 120,
	"./unity.png": 917,
	"./vscode.png": 28,
	"./vuforia.png": 287,
	"./xbox.png": 244
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 552;